//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import { required, requiredIf, helpers } from "vuelidate/lib/validators";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import FabricInput from "@/components/q-fabric-input.vue";
import AQInput from "../../Generics/AQInput/AQInput.vue";
import AQDialog from "../../Generics/AQDialog/AQDialog.vue";
/* eslint-disable vue/no-side-effects-in-computed-properties */
const validScName = helpers.regex("validScName", /^[a-zA-Z0-9]*[a-zA-Z_][a-zA-Z0-9_]*$/);

export default {
    name: "SmartContractModal",
    components: {
        FabricInput,
        AQModal,
        AQDialog,
        AQInput,
        AQDropdown,
        AQCard
    },
    props: {
        scEditMode: {
            type: String,
            default: "create"
        },
        scList: {
            type: Array,
            default: () => []
        },
        currentContract: {}
    },
    data() {
        return {
            defaultValueDrop: "",
            titleDialog: "",
            messageTitle: "",
            openDialog: false,
            hasClose: true,
            scModalOpened: true,
            dirty: false,
            readOnly: false,
            scObject: {
                id: null,
                name: "",
                description: "",
                type: "",
                network: "",
                credentials: "",
                address: ""
            },
            scObjectCopy: {},
            fileImport: null,
            dragCounter: 0,
            createdScObject: {
                id: null,
                processDefinitionId: null,
                name: null,
                properties: null,
                network: {
                    id: "",
                    processDefinitionId: null,
                    name: "",
                    path: "",
                    bcType: {
                        id: "",
                        type: "",
                        label: "",
                        language: ""
                    }
                },
                credentials: {
                    id: "",
                    processDefinitionId: null,
                    name: "",
                    path: "",
                    bcType: {
                        id: "",
                        type: "",
                        label: "",
                        language: ""
                    }
                },
                publishStatus: "UNPUBLISHED",
                bcType: {
                    id: "",
                    type: "",
                    label: "",
                    language: ""
                },
                functionPaginationDtoList: [],
                imported: false,
                optionDefault: null
            }
        };
    },
    validations: {
        scObject: {
            name: { required, validScName },
            type: {
                required: requiredIf(function () {
                    return this.scEditMode !== "import";
                })
            },
            network: { required },
            credentials: {
                required: requiredIf(function () {
                    return !this.currentContract.imported && this.scEditMode !== "import";
                })
            },
            address: {
                required: requiredIf(function () {
                    return this.scEditMode === "import";
                })
            }
        },
        fileImport: {
            required: requiredIf(function () {
                return this.scEditMode === "import";
            })
        }
    },
    computed: {
        ...mapGetters("main", ["getCurrentApplicationId"]),
        ...mapGetters("smartContractDesigner", ["getterScTypes", "getterScCredentials", "getterScNetworks"]),
        ...mapGetters("main", ["getCurrentApplicationId"]),
        checkDuplicates() {
            return this.scList.some(sc => sc.name === this.scObject.name);
        },
        errorLabel() {
            let errorMsg;
            if (!this.$v.scObject.name.validScName) {
                errorMsg = this.$t("smartContract.scNameValidation");
            } else if (this.$v.scObject.name.$error) {
                errorMsg = this.$t("errorRequired");
            } else if (this.checkDuplicates) {
                errorMsg = `${this.$t("smartContract.duplicateScName", { name: this.scObject.name })}`;
            }
            return errorMsg;
        },
        scTypeOptions() {
            this.optionDefault = this.getterScTypes.map(type => ({
                label: type.label,
                value: type.id
            }));
            if (this.scEditMode === "import") {
                this.optionDefault = this.optionDefault.filter(el => el.label === "Etherum");
                this.scObject.type = this.optionDefault && this.optionDefault[0] && this.optionDefault[0].value ? this.optionDefault[0].value : "";
                this.defaultValueDrop = this.optionDefault && this.optionDefault[0] && this.optionDefault[0].value ? this.optionDefault[0].value : "";
            }
            this.getScNetworks(this.scObject.type);
            return this.optionDefault;
        },

        scNetworkOptions() {
            return this.getterScNetworks.map(network => ({
                label: network.name,
                value: network.id
            }));
        },
        scCredentialsOptions() {
            return this.getterScCredentials.map(credential => ({
                label: credential.name,
                value: credential.id
            }));
        },
        computedSCName: {
            get() {
                return this.scObject.name;
            },
            set(newName) {
                this.scObject.name = newName.charAt(0).toUpperCase() + newName.slice(1);
            }
        },
        scAddressLabel() {
            let address = "";
            if (this.scEditMode === "import" || this.currentContract.publishStatus === "IMPORTED" || this.currentContract.publishStatus === "PUBLISHED") {
                address = `${this.$t("smartContract.scAddress")}*`;
            } else {
                this.scObject.address = this.$t("smartContract.scAddressInfo");
                address = this.$t("smartContract.scAddress");
            }
            return address;
        },
        isDisabled() {
            return (this.scEditMode === "edit" && !this.isDirty() && !this.$v.$invalid) || this.$v.$invalid || this.checkDuplicates;
        },
        isEditable() {
            return this.currentContract.publishStatus === "UNPUBLISHED" || this.scEditMode === "create" || this.scEditMode === "import";
        },
        fileName() {
            return this.fileImport && this.fileImport.name ? this.fileImport.name : this.$t("apps.chooseFile");
        },
        saveButtonLabel() {
            return { label: this.$t("smartContract.importBtn"), disabled: this.isDisabled };
        },
        disabledOnImport() {
            return this.scEditMode === "import" || this.currentContract.publishStatus === "IMPORTED";
        }
    },
    activated() {
        window.addEventListener("dragover", this.prevDefault, false);
        window.addEventListener("drop", this.prevDefault, false);
        this.addDragEvents();
    },
    mounted() {
        if (this.scEditMode === "import") {
            Object.assign(this.scObjectCopy, this.scObject);
            this.scObjectCopy.network = [];
            const typeObject = this.getterScTypes.find(type => type.label === "Etherum");

            if (typeObject && typeObject.id) {
                this.getScNetworks(typeObject.id);
            }
        }

        if (this.currentContract && this.currentContract.id !== null) {
            this.getScTypes();
            this.getScNetworksAndCredentials(this.currentContract.bcType.id);
            this.scObject.id = this.currentContract.id;
            this.scObject.name = this.currentContract.name;
            this.scObject.description = this.currentContract.description;
            this.scObject.type = this.currentContract.bcType.id;
            this.scObject.network = (this.currentContract.network && this.currentContract.network.id) ? this.currentContract.network.id : null;
            this.scObject.credentials = (this.currentContract.credentials && this.currentContract.credentials.id) ? this.currentContract.credentials.id : null;
            if (this.currentContract.address) {
                this.scObject.address = this.currentContract.address;
            }
            Object.assign(this.scObjectCopy, this.scObject);
            this.$oneAtATime.createRoom("smartContractList", this.currentContract.id);
            this.$root.$on("oneAtATime-smartContractList", () => {
                this.readOnly = !this.$oneAtATime.state.$currentRoomEmpty;
            });
        } else {
            this.getScTypes();
            Object.assign(this.scObjectCopy, this.scObject);
        }
        window.addEventListener("dragover", this.prevDefault, false);
        window.addEventListener("drop", this.prevDefault, false);
        this.$nextTick(() => {
            this.addDragEvents();
        });
    },
    deactivated() {
        // eslint-disable-next-line vue/no-mutating-props
        this.currentContract = {};
        if (this.scEditMode === "import") {
            this.removeDragEvents();
        }
    },
    beforeDestroy() {
        window.removeEventListener("dragover", this.prevDefault);
        window.removeEventListener("drop", this.prevDefault);
    },
    methods: {
        ...mapActions("smartContractDesigner", ["getScTypes", "getScCredentials", "getScNetworks", "saveSmartContract", "importSmartContract"]),

        isDirty() {
            return JSON.stringify(this.scObject) !== JSON.stringify(this.scObjectCopy);
        },
        hideModal() {
            this.$oneAtATime.destroyCurrentRoom();
            this.$emit("input", false);
        },
        okAction() {
            this.openDialog = false;
            this.hideModal();
        },
        cancelAction() {
            this.openDialog = false;
        },

        action(action) {
            if (action === "close") {
                if (this.isDirty()) {
                    this.titleDialog = this.$t("smartContract.confirmationDialog.title");
                    this.messageTitle = this.$t("smartContract.confirmationDialog.msg");
                    this.openDialog = true;
                } else {
                    this.hideModal();
                }
            } else if (action === "primary") {
                const importScObject = {
                    id: null,
                    applicationId: this.getCurrentApplicationId,
                    name: this.scObject.name,
                    description: this.scObject.description,
                    networkId: this.scObject.network[0].value,
                    bcTypeId: this.optionDefault && this.optionDefault[0] && this.optionDefault[0].value ? this.optionDefault[0].value : null,
                    address: this.scObject.address
                };
                const formDataImport = new FormData();
                formDataImport.append("file", this.fileImport);
                formDataImport.append("contractImportDto", JSON.stringify(importScObject));
                this.importSmartContract(formDataImport).then((data) => {
                    this.$emit("onCreateSc", data.data.smartContract);
                    this.hideModal();
                });
            }
        },
        getScNetworksAndCredentials(scType) {
            this.getScCredentials(scType);
            this.getScNetworks(scType);
        },
        addDragEvents() {
            const upDialog = document.querySelector(".q-responsive-modal");
            upDialog.addEventListener("dragenter", this.dragOverWindow, false);
            upDialog.addEventListener("dragleave", this.dragLeaveWindow, false);
            window.addEventListener("drop", this.dragLeaveWindow, false);
            window.addEventListener("dragleave", this.dragLeaveWindow, false);
            this.$refs.inputFileUpdate.addEventListener("drop", this.inputImportChanged);
            this.$refs.inputFileUpdate.addEventListener("dragenter", this.dragEnter, false);
            this.$refs.inputFileUpdate.addEventListener("dragleave", this.dragLeave, false);
        },
        removeDragEvents() {
            const upDialog = document.querySelector(".q-responsive-modal");
            upDialog.removeEventListener("dragenter", this.dragOverWindow, false);
            upDialog.removeEventListener("dragleave", this.dragLeaveWindow, false);
            window.removeEventListener("drop", this.dragLeaveWindow, false);
            window.removeEventListener("dragleave", this.dragLeaveWindow, false);
            this.$refs.inputFileUpdate.removeEventListener("drop", this.inputImportChanged);
            this.$refs.inputFileUpdate.removeEventListener("dragenter", this.dragEnter, false);
            this.$refs.inputFileUpdate.removeEventListener("dragleave", this.dragLeave, false);
        },
        inputImportChanged(event) {
            let files;
            if (event.type === "drop") {
                files = event.dataTransfer.files;
            } else {
                files = event.target.files;
            }
            this.fileImport = (files && files[0]) ? files[0] : files;
            this.$refs.inputFileUpdate.value = "";
        },
        onCancelUpdate() {
            this.fileImport = null;
            this.$refs.inputFileUpdate.value = "";
        },
        prevDefault(e) {
            e.preventDefault();
        },
        dragEnter() {
            const el = document.querySelector(".inputfile-replacement");
            el.classList.add("inputfile-replacement-hover");
        },
        dragLeave() {
            const el = document.querySelector(".inputfile-replacement");
            el.classList.remove("inputfile-replacement-hover");
            el.classList.add("whitespace-hover");
        },
        dragOverWindow() {
            this.dragCounter++;
            const el = document.querySelector(".inputfile-replacement");
            el.classList.add("whitespace-hover");
        },
        dragLeaveWindow(ev) {
            ev.stopPropagation();
            this.dragCounter--;
            if (this.dragCounter === 0) {
                const el = document.querySelector(".inputfile-replacement");
                el.classList.remove("whitespace-hover");
            }
        }
    }
};
